/** Listings scrapeados con rutas .jpeg rotas en el CDN (legacy Firestore). */
const HELLO_AYA_CDN_HOST = 'search.helloaya.com';
const HELLO_AYA_LEGACY_JPEG_FALLBACK =
  'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800&q=75&fm=webp';

const PROXY_HOSTS = new Set([
  'www.thestayclub.com',
  'thestayclub.com',
  'www.iqstudentaccommodation.com',
  'iqstudentaccommodation.com',
  'assets-us-01.kc-usercontent.com',
  'photos2.theblueground.com',
  'photos.theblueground.com',
  'cdn.theblueground.com',
  'cdn.mews.com',
  'static.mews.com',
  'mason-fifth.com',
  'www.mason-fifth.com',
  'urbancampus.com',
  'www.urbancampus.com',
  /** Hotlink + 404 frecuentes en hashes del CDN — proxy con fallback en backend */
  'search.helloaya.com',
]);

function normalizeHelloAyaImageUrl(imageUrl) {
  try {
    const parsed = new URL(imageUrl);
    if (parsed.hostname !== HELLO_AYA_CDN_HOST) return imageUrl;
    if (!parsed.pathname.includes('/images/upload/')) return imageUrl;
    if (/\.jpe?g$/i.test(parsed.pathname)) {
      return HELLO_AYA_LEGACY_JPEG_FALLBACK;
    }
    return imageUrl;
  } catch {
    return imageUrl;
  }
}

/**
 * Resuelve URLs de imágenes de colivings externos.
 * Algunos proveedores bloquean hotlinking (Stay Club, iQ) — se sirven vía proxy same-origin.
 */
export function resolveColivingImageUrl(imageUrl) {
  if (!imageUrl || typeof imageUrl !== 'string') {
    return '';
  }

  if (!imageUrl.startsWith('https://') && !imageUrl.startsWith('http://')) {
    return imageUrl;
  }

  const normalized = normalizeHelloAyaImageUrl(imageUrl);

  try {
    const { hostname } = new URL(normalized);
    if (PROXY_HOSTS.has(hostname)) {
      return `/api/coliving-image?url=${encodeURIComponent(normalized)}`;
    }
  } catch {
    return normalized;
  }

  return normalized;
}
